import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#434343",
    "col2n": "#FF008C"
}
function HaiHig050({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M30.8 18.9q.65-.75-4.35-7.4Q18.2.55 18.25 0l-.9 1.1q-.3.4-.6.85Q15.9 3.05 15 4.1q-1.25 1.55-2.6 3.1-2.3 2.55-4.75 5-1.6 1.6-3.2 3.1Q2.7 16.9 1 18.55q-.45.4-.95.85H0q.05.05.05.1 3.2 4.85 4.6 7.05.15.2.3.45 1.05 1.6 2 3.3l.7 1.2 1.1 2q.75 1.45 1.5 3l.65 1.25.3.7q.05.1.1.25.05.1.15.25.5 1.1 1 2.25.2.5 2.6 6.9.8-3.7.75-6.9-.05-3.25-.35-6.15-.35-2.95-.35-3.2l.05.1q4.1 13.1 3.15 25.15 4.65-7.55 3.95-12.2 3.6 8 1.3 19.35 3.85-5.45 4.5-10.7.7 1.55.85 5 .15 3.4-.3 6.1 2.05-3.2 2.55-7.1.5-3.9.35-9.1 2.75 8.85 3.65 12.3.7 2.95 1.15 4.3l.05.25v-.2q-2.1-38.2-5.55-46.2z"
                    id="HaiHig050__Symbol_167_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M21.05 16.7q-.4-2.15-.7-4.3-.25-2.15-.7-3.55-1.3-3.75-2.15-5.65-.9-1.9-1.85-3.2h-.1Q17 8.35 17.5 17.15v2.1q0 25.8-11.85 46.7 0 .05-.05.1-.45.85-1 1.75v.05Q2.55 71.25.15 74.6q-.05.05-.05.1-.05 0-.05.1-.05.55-.05 2.15 0 2.65 1.25 7.15Q2 86.8 4 93.15q1.3 4.55 2.2 8.9.35 1.15.65 2.35.65 5.6 1.05 11.55.2-1.25.4-2.45 1.75-12.75.1-24.3 8.55 23.05 9.75 50.7.85-1.65 1.35-5.15 3.95-22.6-.9-51.8 6.1 15.4 4.75 27.2v.5q3.35-8.85 3.5-14.4.1-5.55-.65-10.9-.85-5.3-3.2-13.5-.3-1.1-.55-2.25-.25-2.2-.25-3.65 0-3.75 1.3-9.7 1.25-6 1-11.05-.3-5.1-1.75-11-1.5-5.9-1.4-10.6.05-4.75-.3-6.9z"
                    id="HaiHig050__Symbol_166_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#HaiHig050__Symbol_167_0_Layer0_0_FILL"
                transform="translate(252.5 209.2)"
                id="HaiHig050__col1n"
            />
            <use
                xlinkHref="#HaiHig050__Symbol_166_0_Layer0_0_FILL"
                transform="translate(270.7 134.4)"
                id="HaiHig050__col2n"
            />
        </g></g>
    )
}
export default HaiHig050
